import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import environment from '../../../../environments/environment';
import {
  AssignmentReqBody,
} from '@data-access/assignment';

@Injectable({
  providedIn: 'root',
})
export class AssignStudyService {
  private readonly http = inject(HttpClient);

  searchStudyAccess(queryParams: HttpParams) {
    return this.http.get<{
      id: string;
      int_id: null | number;
      sponsor_name: string;
      wcg_tracking_id: null | string;
      sponsor_protocol_id: string;
    }>(`${environment.irisApi}/study/access/search/`, {
      params: queryParams,
    });
  }

  searchLegacyId(legacyId: string) {
    return this.http.get<{
      id: string;
    }>(`${environment.irisApi}/workspace/check_legacy_id/${legacyId}/`);
  }

  searchSiteId(siteId: number) {
    return this.http.get<{
      id: string;
    }>(`${environment.irisApi}/site/${siteId}/`);
  }

  updateEntity(
    targetType: string,
    entityId: string,
    body: Pick<
      AssignmentReqBody,
      | 'reason'
      | 'entity_type'
      | 'entity_id'
      | 'email'
      | 'first_name'
      | 'last_name'
      | 'legacy_id'
    >,
  ) {
    const url = `${environment.irisApi}/${targetType}/${entityId}/entity/`;
    return this.http.put(url, body);
  }

  updateInvestigator<T extends object>(
    targetType: string,
    entityId: string,
    body: T,
  ) {
    const url = `${environment.irisApi}/${targetType}/${entityId}/investigator/`;
    return this.http.put(url, body);
  }

  updateStudyTitle(
    studyId: string,
    body: Pick<AssignmentReqBody, 'title' | 'reason_for_update'>,
  ) {
    const url = `${environment.irisApi}/study/${studyId}/title/`;
    return this.http.put(url, body);
  }
}
